import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	labelBoardsInProjectLocation: {
		defaultMessage: 'Boards in {locationName}',
		id: 'navigation-apps.scope-switcher-v2.label-boards-in-project-location',
		description:
			'Sidebar - Board switcher - header of section "boards in location" for location of project type',
	},
	labelBoardsInUserLocationNew: {
		defaultMessage: "{locationName}''{lastLetter, select, s {} z {} other {s}} boards",
		id: 'navigation-apps.scope-switcher-v2.label-boards-in-user-location-new',
		description:
			'NEW REACT INTL V5 MESSAGE FORMAT: Sidebar - Board switcher - header of section "boards in location" for location of user type. Saxon genitive is added to the location name',
	},
	otherRecentBoards: {
		defaultMessage: 'Other boards',
		id: 'navigation-apps.scope-switcher-v2.other-recent-boards',
		description: 'Sidebar - Board switcher - header of the second section in board switcher',
	},
	createBoard: {
		defaultMessage: 'Create board',
		id: 'navigation-apps.scope-switcher-v2.create-board',
		description: 'Sidebar - Board switcher - message displayed in Create board button',
	},
	board: {
		defaultMessage: 'Board',
		id: 'navigation-apps.scope-switcher-v2.board',
		description:
			'Sidebar - Board switcher - text displayed in button which opens dropdown if there is no board selected/there are no boards in the project',
	},
	boards: {
		defaultMessage: 'Boards',
		id: 'navigation-apps.scope-switcher-v2.boards',
		description: 'Sidebar - Board switcher - subtext displayed in button which opens dropdown',
	},
	locationDoesNotHaveBoard: {
		defaultMessage: "{location} doesn't have a board",
		id: 'navigation-apps.scope-switcher-v2.location-does-not-have-board',
		description:
			'Sidebar - Board switcher - heading displayed when current location does not have any boards',
	},
	projectLocationDescription: {
		defaultMessage: 'in {location}',
		id: 'navigation-apps.scope-switcher-v2.project-location-description',
		description:
			'Sidebar - Board switcher - subtext displayed in boards in "Other boards" section if board location is project type',
	},
	userLocationDescriptionNew: {
		defaultMessage: "{locationName}''{lastLetter, select, s {} z {} other {s}}",
		id: 'navigation-apps.scope-switcher-v2.user-location-description-new',
		description:
			'NEW REACT INTL V5 MESSAGE FORMAT: Sidebar - Board switcher - subtext displayed in boards in "Other boards" section if board location is user type. Saxon genitive is added to the location name',
	},
	viewAllBoards: {
		defaultMessage: 'View all boards',
		id: 'navigation-apps.scope-switcher-v2.view-all-boards',
		description:
			'Sidebar - Board switcher - text displayed in the link which redirect user to the View all boards page',
	},
	viewAll: {
		defaultMessage: 'View all',
		id: 'navigation-apps.scope-switcher-v2.view-all',
		description:
			'Sidebar - Board switcher - text displayed in the link in the sticky header which redirect user to the View all boards page',
	},
	searchPlaceholder: {
		defaultMessage: 'Search for boards…',
		id: 'navigation-apps.scope-switcher-v2.search-placeholder',
		description: 'Sidebar - Board switcher - placeholder text displayed in search field at the top',
	},
	searchBoardsInLocationLabel: {
		defaultMessage: 'Boards in {locationName}',
		id: 'navigation-apps.scope-switcher-v2.search-boards-in-location-label',
		description:
			'Sidebar - Board switcher - header of section "boards in location" for search results',
	},
	searchBoardsNotInLocationLabel: {
		defaultMessage: 'Other boards',
		id: 'navigation-apps.scope-switcher-v2.search-boards-not-in-location-label',
		description:
			'Sidebar - Board switcher - header of section "boards not in location" for search results',
	},
	searchNoMatchesFound: {
		defaultMessage: 'No results',
		id: 'navigation-apps.scope-switcher-v2.search-no-matches-found',
		description:
			'Sidebar - Board switcher - heading displayed when search did not return any results',
	},
	errorMessage: {
		defaultMessage: "We're having troubles connecting to your boards",
		id: 'navigation-apps.scope-switcher-v2.error-message',
		description:
			'Sidebar - Board switcher - error message displayed if there was an error and we can not display recent boards/result of search',
	},
	showMore: {
		defaultMessage: 'Show { remainingBoards } more',
		id: 'navigation-apps.scope-switcher-v2.show-more',
		description:
			'Sidebar - Board switcher - text displayed in button that is responsible for loading more boards if there are more than were displayed',
	},
});
